<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Ginette is a French-Canadian woman who is past middle age by a few years but very young at heart. She sees beauty all around her with a love of animals which surpasses her tolerance of people at most times. Ginette lives along the rugged Atlantic coast in a small Acadian village in Nova-Scotia. She is also the author of the book, <em>Three Titles:</em> <em>A Trifecta of Novellas</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?66690793